module.exports = __webpack_public_path__ + "img/honor04.50f573af.webp";